import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { Button, Col, Row, Form, Select, Space, Tooltip, Empty } from "antd";
import { DeleteFilled, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useDropzone } from "react-dropzone";
import {
  getListProjectByYear,
  deleteProject,
} from "../../../../services/progressPerformance";

import { SUCCESS_CODE } from "../../../../lib/const";
import { routes } from "../../../../routes";
import ConfirmModal from "../../../../components/modal/confirmModal";
import SuccessModal from "../../../../components/modal/successModal";
import FailModal from "../../../../components/modal/failModal";

// const { Option } = Select;

const ProjectTab = ({ year }) => {
  const navigate = useNavigate();
//   const [isUpdate, setIsUpdate] = useState(false);
//   const [isHover, setIsHover] = useState(false);
//   const [data, setData] = useState([]);
  const [listProject, setListProject] = useState([]);
//   const [yealyId, setYealyId] = useState("");
  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

//   const handleMouseEnter = () => {
//     setIsHover(true);
//   };
//   const handleMouseLeave = () => {
//     setIsHover(false);
//   };

//   const onDrop = async () => {};
//   const { getRootProps, getInputProps } = useDropzone({
//     onDrop,
//     multiple: false,
//   });

  const handleDelete = async () => {
    const res = await deleteProject(confirmModal.id);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      await fetchListProjectByYear();
    } else {
      setFailModal(true);
    }
    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 2000);
    setConfirmModal({
      show: false,
      id: 0,
      type: "",
    });
  };

  const fetchListProjectByYear = useCallback(async () => {
    try {
      const res = await getListProjectByYear({ year: year, projectId: "" });

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        console.log("result_data", result_data);
        setListProject(result_data);
        // setYealyId(_.get(result_data,''))
      }
    } catch (error) {}
  }, [listProject]);

  useEffect(() => {
    fetchListProjectByYear();
  }, []);

  return (
    <>
      <Form onFinish={() => {}} layout="vertical" autoComplete="off">
        <Space
          direction="horizontal"
          style={{
            width: "100%",
            justifyContent: "end",
          }}
        >
          <Button
            onClick={() => navigate(routes.add_project + "/" + year)}
            type="primary"
            style={{
              margin: "0 0 16px 0",
              background: "#2E90FA",
              color: "#fff",
              fontWeight: 500,
            }}
          >
            <PlusOutlined />
            เพิ่มโครงการ
          </Button>
        </Space>
        {_.isEmpty(listProject) === false ? (
          listProject.map((record) => (
            <Row
              gutter={[18, 16]}
              className="card"
              style={{ marginBottom: "12px" }}
            >
              <Col span={24}>
                <Space
                  direction="horizontal"
                  style={{
                    width: "100%",
                    justifyContent: "end",
                  }}
                >
                  <Tooltip
                    title="แก้ไข"
                    color={"#31343A"}
                    key={"edit"}
                    placement="bottom"
                  >
                    <Button
                      shape="circle"
                      icon={<EditOutlined style={{ color: "#F79009" }} />}
                      style={{ backgroundColor: "#FEF1DF", border: "none" }}
                      onClick={() =>
                        navigate(
                          routes.edit_project +
                            "/" +
                            year +
                            "/" +
                            record.projectId
                        )
                      }
                    />
                  </Tooltip>

                  <Tooltip
                    title="ลบ"
                    color={"#31343A"}
                    key={"delete"}
                    placement="bottom"
                  >
                    <Button
                      shape="circle"
                      style={{ backgroundColor: "#FDE7E5", border: "none" }}
                      onClick={() =>
                        setConfirmModal({
                          type: "delete",
                          show: true,
                          id: record.projectId,
                        })
                      }
                    >
                      <DeleteFilled style={{ color: "#F04438" }} />
                    </Button>
                  </Tooltip>
                </Space>
              </Col>

              <Col span={8} className="gutter-row">
                <Form.Item label="ชื่อโครงการ">
                  {record?.projectNameTh ? record?.projectNameTh : "-"}
                </Form.Item>
              </Col>

              <Col span={8} className="gutter-row">
                <Form.Item label="ฝ่าย">
                  {record?.departmentNameTh ? record?.departmentNameTh : "-"}
                </Form.Item>
              </Col>

              <Col span={8} className="gutter-row">
                <Form.Item label="กอง">
                  {record?.divisionNameTh ? record?.divisionNameTh : "-"}
                </Form.Item>
              </Col>

              {/* <Col span={8} className="gutter-row">
                <Form.Item label="ชื่อ-นามสกุล ผู้รับผิดชอบโครงการ">
                  {record?.staffName ? record?.staffName : "-"}
                </Form.Item>
              </Col> */}
            </Row>
          ))
        ) : (
          <Empty />
        )}
      </Form>
      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDelete();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </>
  );
};

export default ProjectTab;
